import { NgModule } from '@angular/core';

import { PessoaSharedModule } from './pessoa-shared.module';

@NgModule({
    imports: [
        PessoaSharedModule
    ]
})
export class PessoaModule { }
